/**
 * Billy.be Custom JavaScript
 * ==========================
 * Consolidated JS for Billy.be Shopify store
 * Last updated: 2026-02-28
 * 
 * Contents:
 * 1. Product Page Slider
 * 2. Tab Component
 */

/* ==========================================================================
   1. PRODUCT PAGE SLIDER
   ========================================================================== */

(function() {
  'use strict';
  
  // Only initialize if slideshow container exists
  const slideshowContainer = document.querySelector('.slideshow-container');
  if (!slideshowContainer) return;
  
  let slideIndex = 1;
  let touchStartX = 0;
  let touchEndX = 0;
  
  // Initialize
  showSlides(slideIndex);
  
  // Expose functions globally for onclick handlers
  window.plusSlides = function(n) {
    showSlides(slideIndex += n);
  };
  
  window.currentSlide = function(n) {
    showSlides(slideIndex = n);
  };
  
  function showSlides(n) {
    const slides = document.getElementsByClassName('mySlides');
    const dots = document.getElementsByClassName('dot');
    
    if (slides.length === 0) return;
    
    if (n > slides.length) slideIndex = 1;
    if (n < 1) slideIndex = slides.length;
    
    // Hide all slides
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = 'none';
    }
    
    // Remove active class from all dots
    for (let i = 0; i < dots.length; i++) {
      dots[i].classList.remove('active');
    }
    
    // Show current slide and activate dot
    slides[slideIndex - 1].style.display = 'block';
    if (dots[slideIndex - 1]) {
      dots[slideIndex - 1].classList.add('active');
    }
  }
  
  // Touch/swipe support for mobile
  slideshowContainer.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  
  slideshowContainer.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
  }, { passive: true });
  
  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        window.plusSlides(1); // Swipe left -> next
      } else {
        window.plusSlides(-1); // Swipe right -> previous
      }
    }
  }
})();

/* ==========================================================================
   2. TAB COMPONENT
   ========================================================================== */

(function() {
  'use strict';
  
  // Only initialize if tabs exist
  const defaultTab = document.getElementById('defaultOpen');
  if (!defaultTab) return;
  
  window.openCity = function(evt, cityName) {
    const tabcontent = document.getElementsByClassName('tabcontent');
    const tablinks = document.getElementsByClassName('tablinks');
    
    // Hide all tab content
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }
    
    // Remove active class from all tabs
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove('active');
    }
    
    // Show selected tab and mark as active
    const selectedTab = document.getElementById(cityName);
    if (selectedTab) {
      selectedTab.style.display = 'block';
    }
    
    if (evt && evt.currentTarget) {
      evt.currentTarget.classList.add('active');
    }
  };
  
  // Auto-click default tab on load
  defaultTab.click();
})();
